"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.attachZoomMeeting = attachZoomMeeting;
exports["default"] = void 0;
exports.getClientAvailabilities = getClientAvailabilities;
exports.getClientEvent = getClientEvent;
exports.getExpertAvailabilities = getExpertAvailabilities;
exports.getExpertEvent = getExpertEvent;
exports.getScheduleInfo = getScheduleInfo;
exports.getScheduleRequest = getScheduleRequest;
exports.getTakenSlots = getTakenSlots;
exports.getZoomNumbers = getZoomNumbers;
exports.isUnlinkedOutlookError = void 0;
exports.notifyClients = notifyClients;
exports.notifyExpert = notifyExpert;
exports.removeClientAvailability = removeClientAvailability;
exports.removeExpertAvailability = removeExpertAvailability;
exports.saveZoomMeeting = saveZoomMeeting;
exports.scheduleInterview = scheduleInterview;

var _api = _interopRequireWildcard(require("./api"));

var _get = _interopRequireDefault(require("lodash/get"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function getClientAvailabilities(projectId) {
  return _api["default"].get("/api/client-to-project-availability/fetch/".concat(projectId)).then(_api.extractData)["catch"](_api.errorHandler);
}

function getExpertAvailabilities(eplId) {
  return _api["default"].get("/api/expert-availability-to-epl/fetch/".concat(eplId)).then(_api.extractData)["catch"](_api.errorHandler);
}

function removeClientAvailability(availabilityId) {
  return _api["default"]["delete"]("/api/client-to-project-availability/".concat(availabilityId)).then(_api.extractData)["catch"](_api.errorHandler);
}

function removeExpertAvailability(availabilityId) {
  return _api["default"]["delete"]("/api/expert-availability-to-epl/".concat(availabilityId)).then(_api.extractData)["catch"](_api.errorHandler);
}

function getTakenSlots(expertId, startTimeAv, endTimeAv, eplId) {
  var baseUrl = "/api/expert-availability-to-epl/".concat(expertId, "/taken-slots");
  return _api["default"].get("".concat(baseUrl, "?startTime=").concat(startTimeAv, "&endTime=").concat(endTimeAv, "&eplId=").concat(eplId)).then(_api.extractData)["catch"](_api.errorHandler);
}

function getScheduleRequest(eplId) {
  return _api["default"].get("/api/expert-project-link/".concat(eplId, "/request-schedule")).then(_api.extractData)["catch"](_api.errorHandler);
}

function scheduleInterview(slot) {
  return _api["default"].post("/api/schedule").then(_api.extractData)["catch"](_api.errorHandler);
}

function notifyExpert(scheduleId, scheduleData) {
  return _api["default"].post("/api/schedule/".concat(scheduleId, "/notify-expert"), scheduleData).then(_api.extractData)["catch"](_api.errorHandler);
}

function notifyClients(scheduleId, scheduleData) {
  return _api["default"].post("/api/schedule/".concat(scheduleId, "/notify-clients"), scheduleData).then(_api.extractData)["catch"](_api.errorHandler);
}

function getZoomNumbers() {
  return _api["default"].get("/api/schedule/zoom-numbers").then(_api.extractData)["catch"](_api.errorHandler);
}

function getExpertEvent(scheduleId) {
  return _api["default"].get("/api/schedule/".concat(scheduleId, "/expert-event")).then(_api.extractData)["catch"](_api.errorHandler);
}

function getClientEvent(scheduleId) {
  return _api["default"].get("/api/schedule/".concat(scheduleId, "/client-event")).then(_api.extractData)["catch"](_api.errorHandler);
}

var isUnlinkedOutlookError = function isUnlinkedOutlookError(error) {
  return (0, _get["default"])(error, 'message', '').indexOf('Outlook account') !== -1;
};

exports.isUnlinkedOutlookError = isUnlinkedOutlookError;

function getScheduleInfo(scheduleId) {
  return _api["default"].get("/api/schedule/".concat(scheduleId)).then(_api.extractData)["catch"](_api.errorHandler);
}

function saveZoomMeeting(scheduleId, meetingData) {
  return _api["default"].put("/api/schedule/".concat(scheduleId, "/zoom-meeting"), meetingData).then(_api.extractData)["catch"](_api.errorHandler);
}

function attachZoomMeeting(scheduleId, attachTo) {
  return _api["default"].put("/api/schedule/".concat(scheduleId, "/attach-zoom-meeting/").concat(attachTo), {}).then(_api.extractData)["catch"](_api.errorHandler);
}

var api = {
  getClientAvailabilities: getClientAvailabilities,
  getExpertAvailabilities: getExpertAvailabilities,
  removeClientAvailability: removeClientAvailability,
  removeExpertAvailability: removeExpertAvailability,
  getTakenSlots: getTakenSlots,
  getScheduleRequest: getScheduleRequest,
  attachZoomMeeting: attachZoomMeeting,
  notifyExpert: notifyExpert,
  notifyClients: notifyClients,
  getZoomNumbers: getZoomNumbers,
  getExpertEvent: getExpertEvent,
  getClientEvent: getClientEvent,
  isUnlinkedOutlookError: isUnlinkedOutlookError,
  getInfo: getScheduleInfo,
  saveZoomMeeting: saveZoomMeeting
};
var _default = api;
exports["default"] = _default;